import React, {
  useContext,
} from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  makeStyles,
  Divider
} from '@material-ui/core';

import Input from '../../../shared/component/FormElements/Input';
import Seletor from '../../../shared/component/FormElements/Seletor';
import Button from '../../../shared/component/FormElements/Button';
import ErrorMessage from '../../../shared/component/UIElements/ErrorMessage';
import LoadingSpinner from '../../../shared/component/UIElements/LoadingSpinner';
import {
  VALIDATOR_REQUIRE,
} from '../../../utils/validators';
import { useForm } from '../../../hooks/form-hook';
import { useHttpClient } from '../../../hooks/http-hook';
import { AuthContext } from '../../../shared/context/auth-context';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  button: {
    color: 'white',
    paddingRight: '40px',
    paddingLeft: '40px',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px'
  },
  header: {
    border: '1px solid #ACACAC',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    '& .MuiCardHeader-title': {
      fontSize: '20px',
      fontWeight: 700,
      fontFamily: 'Roboto',
      color: '#3E3E3E'
    }
  },
  container: {
    borderLeft: '1px solid #ACACAC',
    borderRight: '1px solid #ACACAC',
    borderBottom: '1px solid #ACACAC',
    borderBottomLeftRadius: '4px',
    borderBottomRightRadius: '4px',
    padding: '0px 0px 0px 0px',
    '&:last-child': {
      paddingBottom: 0
    }
  },
  titulo: {
    fontSize: '14px',
    fontWeight: 400,
    color: '#828282',
    textAlign: 'left'
  },
  info: {
    padding: '30px 15px'
  },
  title: {
    backgroundColor: '#2C3E50',
    '& h2': {
      color: 'white',
      fontSize: '18px',
      fontFamily: 'Roboto',
      fontWeight: 500,
    },
  },
}));

const Nicho = (props) => {
  const {
    open,
    sala,
    editar,
    onClose,
    onSalvar
  } = props;
  const auth = useContext(AuthContext);
  const classes = useStyles();
  console.log(auth);
  const {
    isLoading,
    error,
    sendRequest,
    clearError
  } = useHttpClient();
  const [formState, inputHandler] = useForm({
    nome: {
      value: '',
      isValid: false
    },
    movel: {
      value: '',
      isValid: false
    },
  }, false);
  const novoSubmitHandler = async (event) => {
    event.preventDefault();
    try {
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/mapas/nicho${editar ? `/${editar._id}` : ''}`,
        `${editar ? 'PUT' : 'POST'}`,
        JSON.stringify({
          nome: formState.inputs.nome.value,
          movel: formState.inputs.movel.value,
        }),
        {
          'Content-Type': 'application/json',
          'x-access-token': auth.token
        }
      );
      console.log(response);
      if (response.sucesso) {
        console.log('Adicionou nicho à sala!');
        clearError();
        onSalvar();
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <Dialog
      open={open}
      className={classes.dialog}
      onClose={onClose}
      scroll="body"
      fullWidth
      maxWidth="md"
    >
      <DialogTitle
        id="customized-dialog-title"
        onClose={onClose}
        className={classes.title}
      >
        {editar ? 'Editar Nicho' : 'Adicionar Nicho'}
      </DialogTitle>
      <DialogContent dividers>
        <form onSubmit={novoSubmitHandler}>
          <Input
            id="nome"
            element="input"
            type="text"
            label="Nome do Nicho"
            fullWidth
            validators={[VALIDATOR_REQUIRE()]}
            errorText="Insira um nome para o nicho."
            onInput={inputHandler}
            variant="outlined"
            initialValid={editar}
            initialValue={editar ? editar.nome : ''}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Seletor
            id="movel"
            name="movel"
            onInput={inputHandler}
            label="Móvel do Nicho"
            placeholder="Móvel do Nicho"
            blank="Selecione o Móvel do Nicho"
            fullWidth
            variant="outlined"
            data={sala.moveis.map((mov) => {
              return { label: mov.nome, id: mov._id };
            })}
            errorText="Selecione o Móvel do Nicho."
            validators={[VALIDATOR_REQUIRE()]}
            initialValid={editar}
            initialValue={editar ? editar.movel._id : ''}
          />
          <Divider variant="middle" style={{ margin: '30px 0px' }} />
          <Button
            color="secondary"
            disabled={!formState.isValid}
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            marginBottom={5}
            classes={classes.button}
          >
            {editar ? 'Atualizar Nicho' : 'Adicionar Nicho'}
          </Button>
          {isLoading && <LoadingSpinner asOverlay />}
          <ErrorMessage error={error} onClear={clearError} />
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default Nicho;
